import axios from "axios";
import qs from "qs";
import getAxiosInstance from "../common/mhiAxios";
import { isEmpty, isNull } from "../utils/ObjectUtils";
import { UpdateUserList, UserLogin, UserItems, Group } from "./User";

export default {
    // ユーザーログイン
    GetUser(user: UserLogin): Promise<any> {
        return axios
            .post(`${process.env.REACT_APP_API_ENDPOINT}/api/login`, {
                token: user.token,
                email: user.email,
                fullName: user.fullName,
                isNew: user.isNew,
                profileImageUrl: user.profileImageUrl,
                organization: user.organization,
                localAccountId: user.localAccountId,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //ユーザ情報の取得
    GetUserInfoList(): Promise<any> {
        return getAxiosInstance()
            .get("/api/getUserInfoList")
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //グループリストの取得
    GetGroupList(): Promise<any> {
        return getAxiosInstance()
            .get("/api/getGroupList")
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
    //グループリストの更新
    UpdateGroupList(updateList: Group[]): Promise<any> {
        const params = new FormData();
        let groupList = "";
        updateList.map((group) => {
            let videoIds: any[] = [];
            let documentIds: any[] = [];
            let userIds: any[] = [];
            if (group.videoList) group.videoList.map((video) => videoIds.push(String(video.id)));
            if (group.slideList) group.slideList.map((slide) => documentIds.push(String(slide.id)));
            if (group.userList) group.userList.map((user) => userIds.push(String(user.id)));

            if (!isEmpty(groupList)) {
                groupList =
                    groupList +
                    "," +
                    JSON.stringify({
                        id: group.id,
                        title: group.title,
                        documentIds: isNull(documentIds) ? [] : documentIds,
                        description: group.description,
                        videoIds: isNull(videoIds) ? [] : videoIds,
                        userIds: isNull(userIds) ? [] : userIds,
                    });
            } else {
                groupList = JSON.stringify({
                    id: group.id,
                    title: group.title,
                    documentIds: isNull(documentIds) ? [] : documentIds,
                    description: group.description,
                    videoIds: isNull(videoIds) ? [] : videoIds,
                    userIds: isNull(userIds) ? [] : userIds,
                });
            }
            return null;
        });

        if (groupList.length === 0) {
            params.append("groupList", new Blob([" "], { type: "application/json" }));
        } else {
            params.append("groupList", new Blob([groupList], { type: "application/json" }));
        }

        return getAxiosInstance()
            .post("/api/updateGroup", params, {
                headers: { "content-type": "multipart/form-data" },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //ユーザ情報の更新
    UpdateUserInfo(updateListItems: UpdateUserList[]): Promise<any> {
        const params = new FormData();
        let sendUserDataList = "";
        updateListItems.map((row) => {
            params.append(
                "files",
                row.imageFile === null || row.imageFile === undefined
                    ? new File([""], "empty")
                    : row.imageFile
            );

            if (sendUserDataList !== "") {
                sendUserDataList =
                    sendUserDataList +
                    "," +
                    JSON.stringify({
                        id: row.id,
                        fullName: row.fullName,
                        skills: row.skills,
                        skillList: row.skillList,
                        roles: row.roles,
                        group: row.group,
                    });
            } else {
                sendUserDataList = JSON.stringify({
                    id: row.id,
                    fullName: row.fullName,
                    skills: row.skills,
                    skillList: row.skillList,
                    roles: row.roles,
                    group: row.group,
                });
            }
            return null;
        });
        params.append("userInfo", new Blob([sendUserDataList], { type: "application/json" }));

        return getAxiosInstance()
            .post("/api/updateUserInfo", params, {
                headers: { "content-type": "multipart/form-data" },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ユーザープロファイル画像の更新
    UpdateUserImage(imageFile: any, profileItems: UserItems): Promise<any> {
        const params = new FormData();
        params.append("file", imageFile);
        params.append(
            "userProfile",
            new Blob([JSON.stringify(profileItems)], { type: "application/json" })
        );
        return getAxiosInstance()
            .post("/api/updateUserProfileImage", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //ユーザ名前の更新
    UpdateSelfInfo(givenname: string, surname: string): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateSelfInfo", {
                givenname: givenname,
                surname: surname,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //ユーザ情報の取得
    GetSelfInfo(): Promise<any> {
        return getAxiosInstance()
            .post("/api/getSelfInfo")
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // 新規Skill作成
    createNewSkill(skill: string): Promise<any> {
        return getAxiosInstance()
            .post(`/api/createSkill?skill=${skill}`)
            .then(({ data }) => data)
            .catch((error) => {
                return error.response.data;
            });
    },

    //スキルの取得、検索
    GetSkillList(inputSkillList: string[]): Promise<any> {
        return getAxiosInstance()
            .get("/api/getSkillList", { params: { skills: qs.stringify(inputSkillList) } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ユーザー情報同期バッチを実行
    StartSyncBatch(): Promise<any> {
        return getAxiosInstance()
            .post("/api/autoUserAzureToXenera")
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // アクセス可能なメールドメインのリストを取得
    getAccessableEmailDomainList(): Promise<any> {
        return getAxiosInstance()
            .get("/api/getAccessableEmailDomainList")
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //アクセス可能なメールドメインの更新
    updateAccessableEmailDomainList(emailDomainList: string[], userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateAccessableEmailDomainList", {
                emailDomainList: emailDomainList,
                userId: userId,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // アクセス可能なEMAILリストを取得
    getAccessableEmailList(): Promise<any> {
        return getAxiosInstance()
            .get("/api/getAccessableEmailList")
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //アクセス可能なEmailリストの更新
    updateAccessableEmailList(emailList: string[], userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateAccessableEmailList", {
                emailList: emailList,
                userId: userId,
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //ユーザーライセンス情報を取得
    GetUserLicense(subdomain: string): Promise<any> {
        return getAxiosInstance()
            .get("/api/getUserLicense", { params: { subdomain: subdomain } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    //ユーザーの追加
    ImportUsers(uploadUsers: File, userId: number): Promise<any> {
        const params = new FormData();

        params.append("file", uploadUsers);
        params.append(
            "userId",
            new Blob([JSON.stringify(userId)], {
                type: "application/json",
            })
        );


        return getAxiosInstance()
            .post("/api/importUserInfo", params, {
                headers: {
                    accept: "*/*",
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
